export const errorCodeList = {
  "0": "Giao dịch thành công",
  "1": "Mã partner không tồn tại hoặc chưa được kích hoạt",
  "2": "Sai tài khoản hoặc mật khẩu của partner",
  "3": "Session giao dịch không đúng hoặc hết hạn",
  "4": "Không tìm thấy giao dịch cần truy vấn",
  "5": "Request đã tồn tại",
  "6": "Message type không đúng",
  "8": "Giao dịch không thành công",
};
